import { combineActions, handleActions } from "redux-actions";

import compareById from "utils/object/compareById";

import { defaultState } from "../configureStore";

const userReducer = handleActions(
  {
    [combineActions("USER_GET_FULFILLED", "USER_CONFIRM_FULFILLED", "USER_UPDATE_FULFILLED")](
      state,
      { payload: { user } }
    ) {
      return { ...state, currentUser: user };
    },
    USER_LOGOUT: ({ notifications }) => ({
      ...defaultState,
      notifications,
    }),
    USER_INVITE: {
      FULFILLED: () => ({
        isBrokerInviteModalOpen: false,
      }),
    },
    USER_PASSWORD_RESET: {
      PENDING: () => ({
        isResettingPassword: true,
      }),
      FULFILLED: () => ({
        isResettingPassword: false,
      }),
      REJECTED: () => ({
        isResettingPassword: false,
      }),
    },
    OAUTH_GMAIL_TOKEN_SAVE: {
      FULFILLED: ({ currentUser }) => ({
        currentUser: { ...currentUser, hasGmailConnection: true },
      }),
    },
    USER_SIGNUP_GET: {
      FULFILLED: (_state, action) => ({
        registeredUser: action.payload.user,
      }),
    },
    [combineActions("TERMS_OF_SERVICE_CREATE_FULFILLED", "TERMS_OF_SERVICE_SAVE_FULFILLED")](
      state,
      action
    ) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          company: {
            ...state.currentUser.company,
            termsOfService: action.meta.default // eslint-disable-line
              ? action.payload.termsOfService
              : compareById(action.payload.termsOfService, state.currentUser.company.termsOfService)
              ? null
              : state.currentUser.company.termsOfService,
          },
        },
      };
    },
  },
  {},
  { namespace: "_" }
);

export default userReducer;
